module.exports = __webpack_public_path__ + "img/0445_13.62b219b8.jpg";